"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CART_API_URLS = void 0;
var CART_API_URLS;
(function (CART_API_URLS) {
    CART_API_URLS["CART_ADD"] = "/v2/cart/add";
    CART_API_URLS["CART_GET"] = "/v2/cart/get";
    CART_API_URLS["CART_REMOVE_ITEM"] = "/v2/cart/remove";
})(CART_API_URLS = exports.CART_API_URLS || (exports.CART_API_URLS = {}));
